




































import { mapState } from 'vuex';
import { PosWaypoint } from 'gl-ms-positions';
import {
    ACTION_ROUTE,
    ACTION_EMPTY_ROUTE,
    ACTION_SAVE_ROUTE,
    ACTION_SET_WAYPOINTS,
    ACTION_NEW_ROUTE,
    ACTION_UPDATE_WAYPOINT,
    ACTION_SET_WAYPOINT_BY_INDEX,
    ACTION_SET_WAYPOINT,
    ACTION_DELETE_WAYPOINT,
    ACTION_NEW_EMPTY_ROUTE,
    ACTION_SET_EMPTY_WAYPOINT_BY_INDEX,
    ACTION_SET_EMPTY_WAYPOINTS,
    ACTION_SET_EMPTY_WAYPOINT,
    ACTION_UPDATE_EMPTY_WAYPOINT,
    ACTION_DELETE_EMPTY_WAYPOINT,
} from '@/store/modules/planning';
import geoForm from './form.vue';
import geoDetails from './details.vue';

export default {
    data() {
        return {
            activeName: 'route',
        };
    },
    props: ['loadDispo'],
    components: {
        geoForm,
        geoDetails,
    },
    computed: {
        waypoints(this: any) {
            return this.$store.getters.getWaypoints;
        },
        emptyWaypoints(this: any) {
            return this.$store.getters.getEmptyWaypoints;
        },
        getEmptyRoute(this: any) { return this.$store.getters.getEmptyRoute; },
        getRoute(this: any) { return this.$store.getters.getActiveRoute; },
        getOriginalRoute(this: any) { return this.$store.getters.getOriginalRoute; },
        getOriginalEmptyRoute(this: any) { return this.$store.getters.getOriginalEmptyRoute; },
        hasRouteChanged(this: any) { return Boolean(this.$store.getters.editing); },
        hasEmptyRouteChanged(this: any) { return Boolean(this.$store.getters.editingEmpty); },
    },

    methods: {
        async updateWaypoints(this: any, items: PosWaypoint[]) {
            await this.$store.commit(ACTION_SET_WAYPOINTS, items);
            await this.$store.dispatch(ACTION_NEW_ROUTE);
        },
        async addWaypoint(this: any, item: PosWaypoint) {
            if (this.loadDispo) {
                this.$store.commit(ACTION_SET_WAYPOINT_BY_INDEX, { item, index: this.waypoints.length - 1 });
            } else {
                this.$store.commit(ACTION_SET_WAYPOINT, item);
            }

            if (this.waypoints.length > 1) {
                this.$store.dispatch(ACTION_NEW_ROUTE);
            }
        },
        async updateWaypoint(this: any, item: PosWaypoint) {
            await this.$store.commit(ACTION_UPDATE_WAYPOINT, item);
            this.$store.dispatch(ACTION_NEW_ROUTE);
        },
        async deleteWaypoint(this: any, item: PosWaypoint) {
            this.$store.commit(ACTION_DELETE_WAYPOINT, item);
            this.$store.dispatch(ACTION_NEW_ROUTE);
        },
        // Handling empty waypoint
        async updateEmptyWaypoints(this: any, items: PosWaypoint[]) {
            await this.$store.commit(ACTION_SET_EMPTY_WAYPOINTS, items);
            await this.$store.dispatch(ACTION_NEW_EMPTY_ROUTE);
        },
        async addEmptyWaypoint(this: any, item: PosWaypoint) {
            if (this.loadDispo) {
                this.$store.commit(ACTION_SET_EMPTY_WAYPOINT_BY_INDEX, { item, index: this.emptyWaypoints.length - 1 });
            } else {
                this.$store.commit(ACTION_SET_EMPTY_WAYPOINT, item);
            }

            if (this.emptyWaypoints.length > 1) {
                this.$store.dispatch(ACTION_NEW_EMPTY_ROUTE);
            }
        },
        async updateEmptyWaypoint(this: any, item: PosWaypoint) {
            this.$store.commit(ACTION_UPDATE_EMPTY_WAYPOINT, item);
        },
        async deleteEmptyWaypoint(this: any, item: PosWaypoint) {
            this.$store.commit(ACTION_DELETE_EMPTY_WAYPOINT, item);
            this.$store.dispatch(ACTION_NEW_EMPTY_ROUTE);
        },
    },
};
